import { useState } from "react";
import { useSpring, animated } from "react-spring";
import { Box  } from "@mui/material";

import useResponsive from "@/hooks/useResponsive";
import { imageContainerStyles } from "../styles";

interface IProps {
  title: string;
  imageUrl: string;
  thumbnail: string;
}

const CardImage: React.FC<IProps> = ({ title, imageUrl, thumbnail }) => {
  const isMobile = useResponsive("down", "md");
  const [imageLoaded, setImageLoaded] = useState(false); // Image loading state

  // Handle image loading
  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const fadeInProps = useSpring({
    opacity: imageLoaded ? 1 : 0,
    from: { opacity: 0 },
    config: { duration: 300 },
  });

  const fadeInThumbProps = useSpring({
    opacity: imageLoaded ? 0 : 1, // Hide thumbnail when full image is loaded
    from: { opacity: 1 },
    config: { duration: 300 },
    filter: `blur(10px)`,
  });

  return (
    <Box
      display="flex"
      justifyContent={isMobile ? "center" : "end"}
      sx={{
        ...imageContainerStyles, 
        img: {
          width: isMobile ? "100%" : "auto",
          height: "100%",
          objectFit: "contain",
        }
      }}
      mb={{ xs: 2, md: 0 }}
      position='relative'
    >
      <animated.img
        src={thumbnail}
        alt={`${title} preview`}
        style={{
          ...fadeInThumbProps,
          position: "relative",
          zIndex: 1,
          transition: "opacity 0.3s ease",
        }}
      />
      <animated.img
        src={imageUrl}
        alt={title}
        loading='lazy'
        style={{
          ...fadeInProps,
          position: "absolute",
          zIndex: 2,
          top: 0,
          transition: "opacity 0.3s ease",
        }}
        onLoad={handleImageLoad}
      />
    </Box>
  );
};

export default CardImage;
